export function initTopupData(phone, money) {
  return {
    phone: "0376624470",
    money: money,
    isPhoneError: false,
    isMoneyError: false
  }
}

export function initMoneyData() {
  return {
    10: '10,000đ',
    20: '20,000đ',
    30: '30,000đ',
    50: '50,000đ',
    100: '100,000đ',
    200: '200,000đ',
    300: '300,000đ',
    500: '500,000đ'
  }
}